var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlagCmr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_587",
    "data-name": "Ret\\xE2ngulo 587",
    width: 60,
    height: 60,
    transform: "translate(2241 3187)",
    fill: "#fff",
    opacity: 0.41
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flag_CMR",
    transform: "translate(-2241 -3187)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "flag_camaroes",
    transform: "translate(2220.39 3187)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_833",
    "data-name": "Grupo 833",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_488",
    "data-name": "Ret\\xE2ngulo 488",
    width: 34.279,
    height: 59.988,
    fill: "#347b5e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_489",
    "data-name": "Ret\\xE2ngulo 489",
    width: 34.274,
    height: 59.988,
    transform: "translate(34.279)",
    fill: "#bc0030"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_490",
    "data-name": "Ret\\xE2ngulo 490",
    width: 34.282,
    height: 59.988,
    transform: "translate(68.552)",
    fill: "#f3d02f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7317",
    "data-name": "Caminho 7317",
    d: "M377.759,22.384l5.378-3.89h-6.643l-2.05-6.333-2.055,6.333h-6.639l5.374,3.89-2.053,6.307,5.374-3.89,5.371,3.89Z",
    transform: "translate(-323.023 8.687)",
    fill: "#f3d02f"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagCmr);
export default __webpack_public_path__ + "static/media/flag_CMR.7ea11699565daaef476acb4b932ad3f0.svg";
export { ForwardRef as ReactComponent };